import routeListen from "./routeListen";

export default  {

    buildPath(routeName: string, routeParameters: object = {}, suppressHash = false){

        const defaultRouteParams = {
            shortName: routeListen.shortName()
        };

        const internalRouteParamaters:{shortName: string, [key:string]:string} = { ...defaultRouteParams, ...routeParameters }
        
        const routes = this.getRoutes();

        let requestedRoute = {url:""};
        for (let i = 0; i < routes.length; i++) {
            if (routes[i].name === routeName) {
                requestedRoute = routes[i];
                break;
            }
        }

        const qParameterKeys = [];

        let path = requestedRoute.url;

        for (const key in internalRouteParamaters) {
            if (path.indexOf(":" + key) == -1) {
                qParameterKeys.push(key);
            } else {
                path = path.replace(new RegExp(':' + key + '[?]*'), internalRouteParamaters[key]);
            }
        }

        // Remove any optional params from the route that weren't specified
        path = path.replace(/[/]*:(.)[^/]*?\?/g, '');

        if (qParameterKeys.length > 0) {
            path = path + "?";
            let key = qParameterKeys[0];
            path = path + key + "=" + internalRouteParamaters[key];

            for (let i = 1; i < qParameterKeys.length; i++) {
                key = qParameterKeys[i];
                path = path + '&' + key + "=" + internalRouteParamaters[key];
            }

        }

        if (!suppressHash) {
            path = '#' + path;
        }

        return path;
        
    },

    getRoutes() {

        return [
            {
                name: 'AppList',
                url: '/:shortName?/applibrary',
                config: {
                    templateUrl: 'build/templates/app-library.html',
                    controller: 'AppListController',
                    middleware: [
                        'profile-loaded',
                        'check-for-onboarding-steps'
                    ]
                }
            },
            {
                name: 'Login',
                url: '/:shortName?/login',
                config: {
                    templateUrl: "build/templates/login.html",
                    controller: "LoginController",
                    class: 'login-html',
                    middleware: [
                        'check-for-onboarding-steps'
                    ]
                },
                'default': '/login'
            },
            {
                name: 'WorkspaceSelector',
                url: '/Workspace',
                config: {
                    templateUrl: "build/templates/WorkspaceSelector.html",
                    controller: "WorkspaceSelectorController",
                    class: 'login-html',
                    middleware: [
                        'check-for-onboarding-steps'
                    ]
                },
                'default': '/login'
            },
            {
                name: 'Registration',
                url: '/:shortName?/registration',
                config: {
                    templateUrl: "build/templates/registration.html",
                    controller: "RegistrationController",
                    middleware: []
                }
            },
            {
                name: 'ForcePasswordChange',
                url: '/:shortName?/force-password-change',
                config: {
                    templateUrl: "build/templates/force-password-change.html",
                    controller: "ForcePasswordChangeController",
                    controllerAs: 'ctrl',
                    middleware: []
                }
            },
            {
                name: 'RecoveryMethod',
                url: '/:shortName?/registration/recovery',
                config: {
                    templateUrl: "build/templates/recovery-method.html",
                    controller: "RecoveryMethodController",
                    middleware: []
                }
            },
            {
                name: 'RecoveryEmail',
                url: '/:shortName?/registration/recovery/email',
                config: {
                    templateUrl: "build/templates/recovery-email.html",
                    controller: "RecoveryEmailController",
                    middleware: []
                }
            },
            {
                name: 'RecoveryVerifyEmail',
                url: '/:shortName?/registration/recovery/email/verify',
                config: {
                    templateUrl: "build/templates/recovery-email-verify.html",
                    controller: "RecoveryEmailVerifyController",
                    middleware: []
                }
            },
            {
                name: 'RecoveryPhone',
                url: '/:shortName?/registration/recovery/phone',
                config: {
                    templateUrl: "build/templates/recovery-phone.html",
                    controller: "RecoveryPhoneController",
                    middleware: []
                }
            },
            {
                name: 'ChoosePassword',
                url: '/:shortName?/choosepassword',
                config: {
                    templateUrl: "build/templates/choose-password.html",
                    controller: "ChoosePasswordController",
                    middleware: [
                        'profile-loaded'
                    ]
                }
            },
            {
                name: 'ChangeRecoveryPhone',
                url: '/:shortName?/change-recovery-phone',
                config: {
                    templateUrl: "build/templates/change-recovery-phone.html",
                    controller: "ChangeRecoveryPhoneController",
                    middleware: [
                        'profile-loaded'
                    ]
                }
            },
            {
                name: 'PhoneNumber',
                url: '/:shortName?/phonenumber',
                config: {
                    templateUrl: "build/templates/phone-number.html",
                    controller: "PhoneNumberController",
                    middleware: []
                }
            },
            {
                name: 'OneTimePassword',
                url: '/:shortName?/onetimepassword',
                config: {
                    templateUrl: "build/templates/one-time-password.html",
                    controller: "PhoneNumberController",
                    middleware: []
                }
            },
            {
                name: 'ForgotPassword',
                url: '/:shortName?/forgotpassword',
                config: {
                    templateUrl: "build/templates/forgot-password.html",
                    controller: "ForgotPasswordController",
                    controllerAs: 'ctrl',
                    middleware: []
                }
            },
            {
                name: 'ForgotPasswordUwe',
                url: '/:shortName?/forgotpassword/uwe',
                config: {
                    templateUrl: "build/templates/forgot-password-uwe.html",
                    controller: "ForgotPasswordUweController",
                    middleware: []
                }
            },
            {
                //Accessing the profile page from the app library
                name: 'Profile',
                url: '/:shortName?/profile',
                config: {
                    templateUrl: "build/templates/profile.html",
                    controller: "ProfileController",
                    middleware: [
                        'profile-loaded',
                        'check-for-onboarding-steps'
                    ]
                }
            },
            {
                //Accessing the settings page from the app library
                name: 'Settings',
                url: '/:shortName?/settings',
                config: {
                    templateUrl: "build/templates/settings.html",
                    controller: "SettingsController",
                    middleware: [
                        'profile-loaded',
                        'check-for-onboarding-steps'
                    ]
                }
            },
            {
                name: 'ChangePassword',
                url: '/:shortName?/settings/change-password',
                config: {
                    templateUrl: "build/templates/change-password.html",
                    controller: "ChangePasswordController",
                    middleware: [
                        'profile-loaded'
                    ]
                }
            },
            {
                name: 'Post',
                url: '/:shortName?/app/:appGuid/:dataItemId?/post',
                config: {
                    templateUrl: "build/templates/post.html",
                    controller: "PostController",
                    middleware: [
                        'profile-loaded',
                        'check-for-onboarding-steps'
                    ]
                }
            },
            {
                name: 'Recognition',
                url: '/:shortName?/app/:appGuid/:dataItemId?/recognition',
                config: {
                    templateUrl: "build/templates/recognition.html",
                    controller: "RecognitionController",
                    middleware: [
                        'profile-loaded',
                        'check-for-onboarding-steps'
                    ]
                }
            },
            {
                name: 'App',
                url: '/:shortName?/app/:appGuid/:dataItemId?/:itemIndex?',
                config: {
                    templateUrl: "build/templates/app.html",
                    controller: "AppController",
                    middleware: [
                        'profile-loaded',
                        'check-for-onboarding-steps'
                    ]
                }
            },
            {
                name: 'Media',
                url: '/:shortName?/app/:appGuid/:dataItemId?/:itemIndex?/media/:name',
                config: {
                    templateUrl: "build/templates/media.html",
                    controller: "MediaController",
                    middleware: [
                        'profile-loaded',
                        'check-for-onboarding-steps'
                    ]
                }
            },
            {
                name: 'ExternalLogin',
                url: '/:shortName?/externallogin',
                config: {
                    templateUrl: "build/templates/external-login.html",
                    controller: "ExternalLoginController",
                    'class': 'login-html',
                    middleware: []
                }
            },
            {
                name: 'CallBackInternal',
                url: '/:shortName?/callbackinternal',
                config: {
                    templateUrl: "build/templates/callback-internal.html",
                    controller: "CallBackInternalController",
                    middleware: []
                },
                'default': '/login'
            }
        ];
    },

    getInternalPath(item:string) {
        return `/${routeListen.shortName()}/app/${routeListen.appGuid()}/${item}`;
    },

    getBaseOrgPath(item:string) {
        return `/${routeListen.shortName()}/${item}`;
    }
}